// Geometry helpers for the plane-layout confinement area editor.
// Vertices are [x, y] meter pairs, matching the backend `boundary_area` format.

export const round2 = (n) => Math.round(n * 100) / 100;

// Clamp a meter point into the floor rectangle so a saved polygon never has a
// vertex outside bounds (which the backend would reject).
export const clampPoint = (x, y, width, height) => [
  round2(Math.min(Math.max(x, 0), width)),
  round2(Math.min(Math.max(y, 0), height)),
];

// Simple O(n^2) self-intersection test — mirrors the backend `_polygon_self_intersects`
// so the client rejects a bow-tie ring before the save round-trip.
export const isSelfIntersecting = (verts) => {
  const n = verts.length;
  if (n < 4) return false;

  const orient = (p, q, r) =>
    (q[0] - p[0]) * (r[1] - p[1]) - (q[1] - p[1]) * (r[0] - p[0]);

  const crosses = (a, b, c, d) => {
    const o1 = orient(a, b, c);
    const o2 = orient(a, b, d);
    const o3 = orient(c, d, a);
    const o4 = orient(c, d, b);
    return o1 > 0 !== o2 > 0 && o3 > 0 !== o4 > 0;
  };

  for (let i = 0; i < n; i++) {
    const a = verts[i];
    const b = verts[(i + 1) % n];
    for (let j = i + 1; j < n; j++) {
      if ((i + 1) % n === j || (j + 1) % n === i) continue;
      if (crosses(a, b, verts[j], verts[(j + 1) % n])) return true;
    }
  }
  return false;
};
